// extracted by mini-css-extract-plugin
module.exports = {"form__group":"AddTodo_form__group__rQopU","form__field":"AddTodo_form__field__3h3Ds","form__label":"AddTodo_form__label__16aBm"};